// extracted by mini-css-extract-plugin
export default {"witnessJoining":"_lE5sKyPayS3v7OhlGA2"};